export default "__VITE_ASSET__47ae8e77__"